import { isFieldVisibleForGender } from "./isFieldVisibleForGender";

export const buildSubmissionPayload = ({ fields, data, selectedGender, images, turnstileToken, privacyConsent }) => {
    const visibleFieldConfigs = fields.filter((field) => isFieldVisibleForGender(field, selectedGender));
    const visibleFieldValues = {};

    visibleFieldConfigs.forEach((field) => {
        if (data[field.name] !== undefined && data[field.name] !== null) {
            visibleFieldValues[field.name] = data[field.name];
        }
    });

    return {
        fieldConfigs: visibleFieldConfigs,
        fieldValues: visibleFieldValues,
        images,
        turnstileToken,
        privacyAccepted: privacyConsent,
    };
};
